import { BFIExperienceActionsButton } from '../ExperienceComponents';

export const onBFIExperienceActionCellRender = (e, location: Location) => {
    if (!e) {
        return null;
    }
    return (
        <BFIExperienceActionsButton
            experience={e.data}
            location={location}
        />
    );
};
